import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { ROLES } from '@/lib/auth/roles'
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import EnquiriesTable from '@/modules/enquiries/enquiries-table'
import {
  enquiriesQueryOptions,
} from '@/modules/enquiries/enquiries-table/hooks'
import {
  defaultFetchParamsEnquiries, EnquiriesSearch, mergedEnquiriesSchema,
} from "@/types/route-search-schemas";
import { DataLoader } from '@/types/router-context'
import {ENQUIRIES_PATH, ENQUIRIES_URL} from "@/utils/urls";

export const Route = createFileRoute(ENQUIRIES_PATH)({
  component: Enquiries,
  validateSearch: (search: Record<string, unknown>): EnquiriesSearch => validateSearchWithDefaults(mergedEnquiriesSchema, search),
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(ENQUIRIES_URL)) {
      return
    }

    return queryClient.prefetchQuery(enquiriesQueryOptions(defaultFetchParamsEnquiries))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [{ label: 'Enquiries', path: '/enquiries' }],
      children: <div className={'h-10'}></div>
    }
  },
})

function Enquiries() {
  return (
    <Authorisation
      roles={[ROLES.ROLE_EDIT_ENQUIRIES]}
      permissions={[]}
      forbiddenFallback={<Unauthorized />}
    >
      <div className={'flex flex-col items-center justify-center'}>
        <EnquiriesTable />
      </div>
    </Authorisation>
  )
}
